// https://github.com/ReactCorp/cocalero-api/pull/674
// X-Device-Id header is for distinguishing from which device user login
export const X_DEVICE_ID = 'web';
